import { qltClient } from '../clients';
import type { Id, QltTimetableDayCell, QltTimetableWeek } from '../types';

export interface TimetableDayParams {
  scope: 'teacher' | 'class';
  id: Id;
  date: string;
  mode?: 'actual' | 'base';
  withClassNote?: 1 | true;
}

export interface TimetableWeekParams {
  scope: 'teacher' | 'class';
  id: Id;
  weekOf: string;
  mode?: 'actual' | 'base';
}

export const TimetableRepository = {
  fetchDay: (params: TimetableDayParams) =>
    qltClient
      .get('/timetable-day', { params })
      .then((res) => res.data as QltTimetableDayCell[]),

  fetchWeek: (params: TimetableWeekParams) =>
    qltClient.get('/timetable-week', { params }).then((res) => res.data as QltTimetableWeek),
};

export default TimetableRepository;
